import { render, staticRenderFns } from "./RandomTextMessage.vue?vue&type=template&id=167a7c3e&scoped=true"
import script from "./RandomTextMessage.vue?vue&type=script&lang=js"
export * from "./RandomTextMessage.vue?vue&type=script&lang=js"
import style0 from "./RandomTextMessage.vue?vue&type=style&index=0&id=167a7c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167a7c3e",
  null
  
)

export default component.exports